import React from "react";
import Icon from "components/AppIcon";


const CATEGORIES = ["All", "Orientation", "Safety", "Communication", "Leadership", "Health", "Community"];
const FORMATS = ["All", "In-Person", "Online", "Hybrid"];
const DURATIONS = ["All", "Under 2 hours", "2-4 hours", "Half Day", "Full Day", "Multi-Day"];
const STATUS_REQS = ["All", "new", "trained", "established", "senior"];

const STATUS_LABELS = { new: "New", trained: "Trained", established: "Established", senior: "Senior" };

export default function FilterPanel({ filters, onChange, onReset, resultCount, isMobile, onClose }) {
  const handleChange = (key, value) => onChange({ ...filters, [key]: value });

  const FilterSection = ({ label, options, filterKey, labelMap }) => (
    <div className="mb-4">
      <p className="text-xs font-semibold text-[var(--color-foreground)] uppercase tracking-wider mb-2">{label}</p>
      <div className="flex flex-wrap gap-1.5">
        {options?.map((opt) => (
          <button
            key={opt}
            onClick={() => handleChange(filterKey, opt)}
            className={`text-xs px-3 py-1.5 rounded-full border transition-all duration-150 font-medium min-h-[32px] ${
              filters?.[filterKey] === opt
                ? "bg-[var(--color-primary)] text-white border-[var(--color-primary)]"
                : "bg-[var(--color-card)] text-[var(--color-muted-foreground)] border-[var(--color-border)] hover:border-[var(--color-primary)] hover:text-[var(--color-primary)]"
            }`}
          >
            {labelMap ? (labelMap?.[opt] || opt) : opt}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={16} color="var(--color-primary)" />
          <span className="font-heading font-semibold text-sm text-[var(--color-foreground)]">Filters</span>
          <span className="text-xs bg-[var(--color-muted)] text-[var(--color-muted-foreground)] px-2 py-0.5 rounded-full">
            {resultCount} courses
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onReset}
            className="text-xs text-[var(--color-primary)] hover:underline font-medium"
          >
            Reset
          </button>
          {isMobile && (
            <button onClick={onClose} className="p-1 rounded hover:bg-[var(--color-muted)]">
              <Icon name="X" size={16} color="var(--color-muted-foreground)" />
            </button>
          )}
        </div>
      </div>
      <FilterSection label="Category" options={CATEGORIES} filterKey="category" labelMap={undefined} />
      <FilterSection label="Format" options={FORMATS} filterKey="format" labelMap={undefined} />
      <FilterSection label="Duration" options={DURATIONS} filterKey="duration" labelMap={undefined} />
      <FilterSection label="Status Requirement" options={STATUS_REQS} filterKey="statusReq" labelMap={{ ...STATUS_LABELS, All: "All" }} />
      <div className="mb-2">
        <p className="text-xs font-semibold text-[var(--color-foreground)] uppercase tracking-wider mb-2">Sort By</p>
        <div className="flex flex-wrap gap-1.5">
          {["Newest", "Duration", "Popularity", "Alphabetical"]?.map((opt) => (
            <button
              key={opt}
              onClick={() => handleChange("sortBy", opt)}
              className={`text-xs px-3 py-1.5 rounded-full border transition-all duration-150 font-medium min-h-[32px] ${
                filters?.sortBy === opt
                  ? "bg-[var(--color-primary)] text-white border-[var(--color-primary)]"
                  : "bg-[var(--color-card)] text-[var(--color-muted-foreground)] border-[var(--color-border)] hover:border-[var(--color-primary)] hover:text-[var(--color-primary)]"
              }`}
            >
              {opt}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}